import { render, staticRenderFns, recyclableRender, components } from "./list.vue?vue&type=template&id=41e92bcc&scoped=true&"
var renderjs
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=41e92bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e92bcc",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/vehicle/list.vue"
export default component.exports